import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
export const connect = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: connect.url(args, options),
    method: 'get',
})

connect.definition = {
    methods: ["get","head"],
    url: '/app/creator/platform/{platform}/connect',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
connect.url = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { platform: args }
    }

    if (Array.isArray(args)) {
        args = {
            platform: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        platform: args.platform,
    }

    return connect.definition.url
            .replace('{platform}', parsedArgs.platform.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
connect.get = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: connect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
connect.head = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: connect.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
const connectForm = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
connectForm.get = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:26
* @route '/app/creator/platform/{platform}/connect'
*/
connectForm.head = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connect.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

connect.form = connectForm

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
export const callback = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/app/creator/platform/{platform}/callback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
callback.url = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { platform: args }
    }

    if (Array.isArray(args)) {
        args = {
            platform: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        platform: args.platform,
    }

    return callback.definition.url
            .replace('{platform}', parsedArgs.platform.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
callback.get = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
callback.head = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
const callbackForm = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
callbackForm.get = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::callback
* @see app/Http/Controllers/Creator/PlatformConnectController.php:39
* @route '/app/creator/platform/{platform}/callback'
*/
callbackForm.head = (args: { platform: string | number } | [platform: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

callback.form = callbackForm

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
export const connections = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: connections.url(options),
    method: 'get',
})

connections.definition = {
    methods: ["get","head"],
    url: '/app/creator/platform/connections',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
connections.url = (options?: RouteQueryOptions) => {
    return connections.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
connections.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: connections.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
connections.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: connections.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
const connectionsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connections.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
connectionsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connections.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::connections
* @see app/Http/Controllers/Creator/PlatformConnectController.php:83
* @route '/app/creator/platform/connections'
*/
connectionsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connections.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

connections.form = connectionsForm

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
export const guilds = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: guilds.url(args, options),
    method: 'get',
})

guilds.definition = {
    methods: ["get","head"],
    url: '/app/creator/platform/connections/{connection}/guilds',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
guilds.url = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { connection: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { connection: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            connection: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        connection: typeof args.connection === 'object'
        ? args.connection.uuid
        : args.connection,
    }

    return guilds.definition.url
            .replace('{connection}', parsedArgs.connection.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
guilds.get = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: guilds.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
guilds.head = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: guilds.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
const guildsForm = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: guilds.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
guildsForm.get = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: guilds.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::guilds
* @see app/Http/Controllers/Creator/PlatformConnectController.php:94
* @route '/app/creator/platform/connections/{connection}/guilds'
*/
guildsForm.head = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: guilds.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

guilds.form = guildsForm

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::disconnect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:109
* @route '/app/creator/platform/connections/{connection}'
*/
export const disconnect = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disconnect.url(args, options),
    method: 'delete',
})

disconnect.definition = {
    methods: ["delete"],
    url: '/app/creator/platform/connections/{connection}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::disconnect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:109
* @route '/app/creator/platform/connections/{connection}'
*/
disconnect.url = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { connection: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { connection: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            connection: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        connection: typeof args.connection === 'object'
        ? args.connection.uuid
        : args.connection,
    }

    return disconnect.definition.url
            .replace('{connection}', parsedArgs.connection.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::disconnect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:109
* @route '/app/creator/platform/connections/{connection}'
*/
disconnect.delete = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disconnect.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::disconnect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:109
* @route '/app/creator/platform/connections/{connection}'
*/
const disconnectForm = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: disconnect.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PlatformConnectController::disconnect
* @see app/Http/Controllers/Creator/PlatformConnectController.php:109
* @route '/app/creator/platform/connections/{connection}'
*/
disconnectForm.delete = (args: { connection: string | { uuid: string } } | [connection: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: disconnect.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

disconnect.form = disconnectForm

const platform = {
    connect: Object.assign(connect, connect),
    callback: Object.assign(callback, callback),
    connections: Object.assign(connections, connections),
    guilds: Object.assign(guilds, guilds),
    disconnect: Object.assign(disconnect, disconnect),
}

export default platform